import useTabParam from "components/hooks/useTabParam";
import GiftCategories from "../GiftCategories/components/GiftCategories";
import GiftOrders from "../GiftOrders/components/GiftOrders";
import Logos from "../Logos/components/Logos";
import PageHeader from "components/PageHeader";
import DSSegmentedTabs from "views/system-design/DSSegmentedTabs";

const Gifts = () => {
  const [tabParam, setLayout] = useTabParam("tab", "categories", [
    "categories",
    "orders",
    "logos",
  ]);
  const layout = tabParam as "categories" | "orders" | "logos" | undefined;
  return (
    <>
      <PageHeader
        overline="Commerce"
        title="Greets"
        subtitle="Manage greet categories, gift orders, and partner logos."
        tabs={
          <DSSegmentedTabs<"categories" | "orders" | "logos">
            options={[
              { label: "Categories", value: "categories" },
              { label: "Orders", value: "orders" },
              { label: "Logos", value: "logos" },
            ]}
            value={layout}
            onChange={setLayout}
          />
        }
      />
      {layout === "categories" && <GiftCategories />}
      {layout === "orders" && <GiftOrders />}
      {layout === "logos" && <Logos />}
    </>
  );
};
export default Gifts;
